function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { capitalCase, kebabCase } from "change-case";
import pluralizeRaw from "pluralize";
import ArrayUtil from "../ArrayUtil/ArrayUtil.js";
import { PERSONAL_EMAIL_DOMAINS } from "../DomainUtil/constants.js";
import DomainUtil from "../DomainUtil/DomainUtil.js";
/**
 * Utilities for working with strings.
 *
 * Provides a set of static methods to perform common string manipulations such as
 * formatting, normalization, and slugification.
 *
 * @author @Mxs2019
 */ var StringUtil = /*#__PURE__*/ function() {
    "use strict";
    function StringUtil() {
        _class_call_check(this, StringUtil);
    }
    _create_class(StringUtil, null, [
        {
            key: "formatAsReadableTitle",
            value: /**
   * Formats a string into a human-readable title.
   *
   * If the string looks like an ID, it is returned as is. Otherwise, it undergoes
   * a series of transformations including normalization, insertion of spaces before
   * capital letters, replacement of underscores and dashes with spaces, conversion
   * to lowercase, and capitalization of words.
   *
   * @example
   * helloWorld -> Hello World
   * hello-world -> Hello World
   * hello_world -> Hello World
   * helloWorld123 -> Hello World 123
   * clt28aey40842dfaiylp2ulym -> clt28aey40842dfaiylp2ulym
   *
   * @param str The string to format.
   * @returns The formatted string.
   */ function formatAsReadableTitle() {
                var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                if (!str) {
                    return "";
                }
                if (this.looksLikeId(str)) {
                    return str;
                }
                str = this.insertSpacesAroundNumbers(str);
                str = capitalCase(str);
                str = this.uppercaseCommonAcronyms(str);
                return str;
            }
        },
        {
            key: "slugify",
            value: /**
   * Converts a string into a URL-friendly slug.
   *
   * This involves converting the string to lowercase, replacing non-alphanumeric
   * characters with hyphens, and trimming hyphens from the start and end.
   *
   * @param str The string to slugify.
   * @returns The slugified string.
   */ function slugify(str) {
                if (!str.trim()) {
                    return "";
                }
                var hasSpecialCharAtEnd = str.endsWith(" ") || str.endsWith("-");
                if (hasSpecialCharAtEnd) {
                    str = str.slice(0, -1); // Remove the space at the end
                }
                var result = kebabCase(str);
                return hasSpecialCharAtEnd ? result.concat("-") : result;
            }
        },
        {
            key: "insertSpacesAroundNumbers",
            value: function insertSpacesAroundNumbers(str) {
                return str.replace(/(\d+)/g, " $1 ");
            }
        },
        {
            key: "looksLikeId",
            value: /**
   * Roughly tests if a string looks like an ID.
   *
   * This is determined by checking if the string consists of 15 or more
   * alphanumeric characters.
   *
   * @param str The string to test.
   * @returns True if the string looks like an ID, false otherwise.
   */ function looksLikeId(str) {
                return /^[a-z0-9]{15,}$/.test(str);
            }
        },
        {
            key: "uppercaseCommonAcronyms",
            value: /**
   * Uppercases common acronyms in a string.
   */ function uppercaseCommonAcronyms(str) {
                var commonAcronyms = [
                    "API",
                    "URL",
                    "HTTP",
                    "ID",
                    "JSON",
                    "UUID",
                    "HTML",
                    "CSS",
                    "PDF",
                    "CSV",
                    "XML",
                    "SQL",
                    "CLI",
                    "HTTPS",
                    "FTP",
                    "DNS",
                    "SMTP",
                    "POP3",
                    "IMAP",
                    "TCP",
                    "UDP",
                    "SSL",
                    "SSH",
                    "SERP",
                    "DB",
                    "DBMS",
                    "DBA",
                    "RDBMS"
                ];
                var words = str.split(" ");
                return words.map(function(word) {
                    if (commonAcronyms.includes(word.toUpperCase())) {
                        return word.toUpperCase();
                    }
                    return word;
                }).join(" ");
            }
        },
        {
            key: "pluralize",
            value: function pluralize(word, count, includeCount) {
                return pluralizeRaw(word, count, includeCount);
            }
        },
        {
            key: "parseName",
            value: /**
   * Attempts to parse a name into first and last name.
   *
   * The first word is assumed to be the first name, and all words after the first are assumed to be the last name.
   */ function parseName(name) {
                if (!name) {
                    return {
                        firstName: undefined,
                        lastName: undefined
                    };
                }
                var _name_split = _to_array(name.split(" ")), firstName = _name_split[0], lastName = _name_split.slice(1);
                return {
                    firstName: firstName,
                    lastName: lastName.join(" ")
                };
            }
        },
        {
            key: "joinArray",
            value: function joinArray(items) {
                var conjunction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "and", oxfordComma = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var cleaned = ArrayUtil.clean(items);
                if (!cleaned.length) {
                    return "";
                } else if (cleaned.length === 1) {
                    return cleaned[0];
                } else if (cleaned.length === 2) {
                    return "".concat(cleaned[0], " ").concat(conjunction, " ").concat(cleaned[1]);
                }
                return "".concat(cleaned.slice(0, -1).join(", ")).concat(oxfordComma ? "," : "", " ").concat(conjunction, " ").concat(cleaned.slice(-1)[0]);
            }
        },
        {
            key: "joinArrayWithOverflow",
            value: function joinArrayWithOverflow(items, options) {
                items = ArrayUtil.clean(items);
                var _options_maxItems;
                var maxItems = (_options_maxItems = options.maxItems) !== null && _options_maxItems !== void 0 ? _options_maxItems : 5;
                if (items.length <= maxItems + 1) {
                    return StringUtil.joinArray(items, options.conjunction, options.oxfordComma);
                } else {
                    var itemsToShow = items.slice(0, maxItems);
                    var itemsNotShown = items.length - maxItems;
                    return StringUtil.joinArray(_to_consumable_array(itemsToShow).concat([
                        pluralizeRaw("more ".concat(options.noun), itemsNotShown, true)
                    ]), options.conjunction, options.oxfordComma);
                }
            }
        },
        {
            key: "stripOuterQuotes",
            value: /**
   * Strips quotes from the beginning and end of a string, if present.
   */ function stripOuterQuotes(str) {
                if (str.startsWith('"') && str.endsWith('"') || str.startsWith("'") && str.endsWith("'")) {
                    return str.slice(1, -1);
                }
                return str;
            }
        },
        {
            key: "guessCompanyNameFromEmail",
            value: function guessCompanyNameFromEmail(email) {
                var domain = DomainUtil.parseEmailDomain(email);
                if (!domain) {
                    return null;
                }
                if (PERSONAL_EMAIL_DOMAINS.has(domain)) {
                    return null;
                }
                var companyName = domain.split(".")[0];
                return capitalCase(companyName);
            }
        },
        {
            key: "truncate",
            value: /**
   * Truncates a string to a specified length, optionally adding ellipsis.
   *
   * @param str The string to truncate
   * @param maxLength The maximum length of the string
   * @param addEllipsis Whether to add "..." when truncating (default: true)
   * @returns The truncated string
   */ function truncate(str, maxLength) {
                var addEllipsis = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                if (!str || str.length <= maxLength) {
                    return str;
                }
                if (addEllipsis) {
                    if (maxLength < 4) {
                        return "...";
                    }
                    return str.slice(0, maxLength - 3) + "...";
                }
                return str.slice(0, maxLength);
            }
        }
    ]);
    return StringUtil;
}();
export default StringUtil;
